import { httpV2 } from "../http.js";

const CRMService = {
  listOpenTasks: (filters) => httpV2.get(`/crm-activities/tasks?${new URLSearchParams(filters)}`),
  getTaskAssignees: () => httpV2.get("/crm-activities/task-assignees"),
  getReservationNotes: (id) => httpV2.get(`/crm-reservations/${id}/notes`),
  saveReservationNotes: (id, data) => httpV2.put(`/crm-reservations/${id}/notes`, data),
  searchAllPeople: (criteria) => httpV2.get(`/contacts/search-all?${new URLSearchParams(criteria)}`),
  getCounts: () => httpV2.get("/contacts/counts"),
  searchContacts: (criteria) =>
    httpV2.get(`/contacts/search?${new URLSearchParams(criteria).toString()}`),
  searchGuests: (criteria) =>
    httpV2.get(`/guests/search?${new URLSearchParams(criteria).toString()}`),
  insertGuest: (guest) => httpV2.post("/guests", guest),
  getContactById: (contactId) => httpV2.get(`/contacts/${contactId}`),
  insertContact: (objContact) => httpV2.post("/contacts", objContact),
  updateContact: (objContact) =>
    httpV2.put(`/contacts/${objContact.id}`, objContact),
  deleteContact: (objContact) =>
    httpV2.delete(`/contacts/${objContact.id}`),
  importContacts: (contactsArr) => httpV2.post("/contacts/import", contactsArr),
  sendMessageToContacts: (objMessage) =>
    httpV2.post("/contacts/message", objMessage),
  getContactTimeline: (contactId, params = {}) => {
    const query = new URLSearchParams();
    if (params.per != null) query.set("per", String(params.per));
    if (params.page != null) query.set("page", String(params.page));
    const qs = query.toString();
    return httpV2.get(`/contacts/${contactId}/timeline${qs ? `?${qs}` : ""}`);
  },
  getGuestTimeline: (guestId, params = {}) => {
    const query = new URLSearchParams();
    if (params.per != null) query.set("per", String(params.per));
    if (params.page != null) query.set("page", String(params.page));
    const qs = query.toString();
    return httpV2.get(`/guests/${guestId}/timeline${qs ? `?${qs}` : ""}`);
  },
  createNote: (note) => httpV2.post("/notes", note),

  // ─── CRM Activities ───
  getAllActivity: (entityType, entityId) =>
    httpV2.get(`/crm-activities/${entityType}/${entityId}/all`),

  // Notes
  getNotes: (entityType, entityId) =>
    httpV2.get(`/crm-activities/${entityType}/${entityId}/notes`),
  createCrmNote: (data) => httpV2.post("/crm-activities/notes", data),
  updateCrmNote: (id, data) => httpV2.put(`/crm-activities/notes/${id}`, data),
  deleteCrmNote: (id) => httpV2.delete(`/crm-activities/notes/${id}`),

  // Tasks
  getTasks: (entityType, entityId) =>
    httpV2.get(`/crm-activities/${entityType}/${entityId}/tasks`),
  createTask: (data) => httpV2.post("/crm-activities/tasks", data),
  updateTask: (id, data) => httpV2.put(`/crm-activities/tasks/${id}`, data),
  deleteTask: (id) => httpV2.delete(`/crm-activities/tasks/${id}`),

  // Calls
  getCalls: (entityType, entityId) =>
    httpV2.get(`/crm-activities/${entityType}/${entityId}/calls`),
  createCall: (data) => httpV2.post("/crm-activities/calls", data),
  updateCall: (id, data) => httpV2.put(`/crm-activities/calls/${id}`, data),
  deleteCall: (id) => httpV2.delete(`/crm-activities/calls/${id}`),

  // Emails
  getEmails: (entityType, entityId) =>
    httpV2.get(`/crm-activities/${entityType}/${entityId}/emails`),
  createEmail: (data) => httpV2.post("/crm-activities/emails", data),
  updateEmail: (id, data) => httpV2.put(`/crm-activities/emails/${id}`, data),
  deleteEmail: (id) => httpV2.delete(`/crm-activities/emails/${id}`),

  // Events
  getEvents: (entityType, entityId) =>
    httpV2.get(`/crm-activities/${entityType}/${entityId}/events`),
  createEvent: (data) => httpV2.post("/crm-activities/events", data),
  updateEvent: (id, data) => httpV2.put(`/crm-activities/events/${id}`, data),
  deleteEvent: (id) => httpV2.delete(`/crm-activities/events/${id}`),

  // ─── Custom Fields ───
  getCustomFieldDefinitions: (entity_type, include_inactive) => {
    const params = new URLSearchParams();
    if (entity_type) params.set("entity_type", entity_type);
    if (include_inactive) params.set("include_inactive", "true");
    const qs = params.toString();
    return httpV2.get(`/custom-fields/definitions${qs ? `?${qs}` : ""}`);
  },
  createCustomFieldDefinition: (data) =>
    httpV2.post("/custom-fields/definitions", data),
  updateCustomFieldDefinition: (id, data) =>
    httpV2.put(`/custom-fields/definitions/${id}`, data),
  toggleCustomFieldDefinition: (id, is_active) =>
    httpV2.patch(`/custom-fields/definitions/${id}/toggle`, { is_active }),
  reorderCustomFieldDefinitions: (ordered_ids) =>
    httpV2.put("/custom-fields/definitions/reorder", { ordered_ids }),

  getCustomFieldValues: (entity_type, entity_id) =>
    httpV2.get(`/custom-fields/values/${entity_type}/${entity_id}`),
  upsertCustomFieldValue: (data) =>
    httpV2.post("/custom-fields/values", data),
  bulkUpsertCustomFieldValues: (data) =>
    httpV2.post("/custom-fields/values/bulk", data),
};

export default CRMService;
